import { useState, useEffect } from 'react';
import { useDocument } from './useDocument';
const useMobileMenu = () => {
    const [mobilePages, setMobilePages] = useState([]);
    const myDocument = useDocument();
    const closeAllPages = () => {
        setMobilePages(mobilePages.map((x) => ({ ...x, isOpen: false })));
    };
    const closeLastPage = () => {
        if (mobilePages.length > 0)
            setMobilePages(mobilePages.map((page, i) => (i + 1 === mobilePages.length ? { ...page, isOpen: false } : page)));
    };
    const addPage = (pages, page) => {
        setMobilePages([...pages, page]);
    };
    useEffect(() => {
        const hasClosedPages = mobilePages.some((p) => !p.isOpen);
        if (hasClosedPages) {
            setTimeout(() => {
                setMobilePages(mobilePages.filter((p) => p.isOpen));
            }, 200);
        }
        if (!myDocument) {
            return;
        }
        if (mobilePages.length) {
            myDocument.body.classList.add('modal-open');
        }
        else {
            myDocument.body.classList.remove('modal-open');
        }
    }, [mobilePages, myDocument]);
    return { mobilePages, closeAllPages, addPage, closeLastPage };
};
export default useMobileMenu;
